import { Maybe } from 'monet';

import { ThirdPartySummary } from 'api/cms/thirdPartySummaries';

export const findAvailableModal = (modalIds: string[] | string) => (
  summaries: ThirdPartySummary[]
) =>
  Maybe.fromEmpty(
    (Array.isArray(modalIds) ? modalIds : [modalIds]).find(
      (level) => !summaries.map(({ modalId }) => modalId).includes(level)
    )
  );
